export default __webpack_public_path__ + "static/media/2p_side.e07799bb.png";